/**
 * Tracking ligero de actividad de la app.
 *
 * - `trackEvent(type, name, metadata)`: fire-and-forget. Nunca lanza.
 * - `getSessionId()`: UUID por sesión de pestaña (sessionStorage).
 *
 * El backend asocia automáticamente `user_id` si el JWT está presente.
 */

import { analyticsAllowed } from './cookieConsent';

const SESSION_KEY = 'tp_session_id';

function uuid() {
  // Versión simple v4-ish suficiente para identificar sesiones anónimas
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = uuid();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch (_) {
    // Modo privado de Safari u otros: degradar silenciosamente
    return null;
  }
}

export function trackEvent(eventType, eventName, metadata = null) {
  try {
    if (!eventType || !eventName) return;
    // Solo si la persona ha aceptado las cookies de estadísticas
    if (!analyticsAllowed()) return;

    const url = `${process.env.REACT_APP_API_URL}/api/track-event`;
    const token = (typeof localStorage !== 'undefined') ? localStorage.getItem('token') : null;

    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    const body = JSON.stringify({
      session_id: getSessionId(),
      event_type: eventType,
      event_name: eventName,
      metadata: metadata || undefined
    });

    // keepalive permite que el request sobreviva si el usuario navega antes de que termine
    fetch(url, {
      method: 'POST',
      headers,
      body,
      keepalive: true
    }).catch(() => { /* silencioso */ });
  } catch (_) {
    // Nunca debe romper la UX
  }
}

const analytics = { trackEvent, getSessionId };

export default analytics;
